<template>
    <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" @verify="validate" ref="recaptcha" size="invisible" @expired="onCaptchaExpired" />
</template>
<script>
    import Vue from "vue";
    import VueRecaptcha from 'vue-recaptcha'
    import Validation from '../recaptchaValidate'
    export default {
        components: { VueRecaptcha },
        props: {
            sitekey: String
        },
        data() {
            return {
                test: null
            }
        },
        methods: {
            validate(response) {
                Validation.validate({ Response: response }).then(result => {
                    this.$emit('validate', result.Success)
                }).catch(error => console.log(error))
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/PasswordReset/Recaptcha.vue